<template>
  <div>
    <div class="row row-equal">
      <div class="flex md12">
        <va-card>
          <va-data-table
            class="va-table--hoverable va-table--stripped no-overflow"
            :fields="fields"
            :data="dataTable"
            :no-data-label="$t('poissonnierTable.empty')"
            :per-page="10"
            @row-clicked="showNoRelance"
            clickable
            page="3"
          ></va-data-table>
        </va-card>
      </div>
    </div>
    <remove-from-campaign
      v-model="showCampaignRemove"
      :identreprise="selectedEntreprise"
      :nomEntreprise="selectedEntrepriseName"
      v-on:reset="loadList"
    />
  </div>
</template>

<script>
import moment from "moment";

import axios from "axios";
import RemoveFromCampaign from "./RemoveFromCampaign";

export default {
  components: { RemoveFromCampaign },

  data() {
    return {
      selectedEntreprise: null,
      selectedEntrepriseName: null,
      showCampaignRemove: false,
      dataTable: []
    };
  },
  computed: {
    fields() {
      return [
        {
          name: "nom",
          title: this.$t("poissonnierTable.headings.enseigne"),
          sortField: "nom",
          width: "15%"
        },
        {
          name: "contact_name",
          title: "Gérant",
          sortField: "contact_name",
          width: "15%"
        },
        {
          name: "unpf",
          title: "Sortie du plan UNPF jusqu'au",
          sortField: "unpf",
          width: "15%"
        },
        {
          name: "spef",
          title: "Sortie du plan SPEF jusqu'au",
          sortField: "spef",
          width: "15%"
        },

        {
          name: "comment",
          title: "Commentaire",
          sortField: "comment",
          width: "15%"
        }
      ];
    }
  },
  mounted() {
    this.loadList();
  },
  methods: {
    showNoRelance(entreprise) {
      this.selectedEntreprise = entreprise.identreprise;
      this.nomEntreprise = entreprise.nom;
      this.showCampaignRemove = true;
    },
    async loadList() {
      try {
        let response = await axios.get("/api/campagne/norelance");

        response.data.forEach(element => {
          if (element.spef) {
            if (moment(element.spef, "YYYY-MM-DD").isBefore(moment())) {
              element.spef = "Dans le plan";
            } else {
              element.spef = moment(element.spef, "YYYY-MM-DD").format(
                "DD-MM-YYYY"
              );
            }
            if (element.spef === "31-12-9999") {
              element.spef = "Définitivement";
            }
          } else {
            element.spef = "";
          }
          if (element.unpf) {
            if (moment(element.unpf, "YYYY-MM-DD").isBefore(moment())) {
              element.unpf = "Dans le plan";
            } else {
              element.unpf = moment(element.unpf, "YYYY-MM-DD").format(
                "DD-MM-YYYY"
              );
            }
            if (element.unpf === "31-12-9999") {
              element.unpf = "Définitivement";
            }
          } else {
            element.unpf = "";
          }
        });
        this.dataTable = response.data;
      } catch (err) {
        console.log(err);
      }
    }
  }
};
</script>

<style>
</style>
